import React, { useState }  from 'react';
import './index.scss';
import {pathServer} from "../../../shared/constants/Constants";
import {Button} from "../../atoms";
import ModalCategory from "../../organisms/modalCategory/ModalCategory";
import {mapToSelect} from "../../../../scripts/Util";
import PSLoading from "../../PSLoading";
import PSIcon from "../../PSIcon";
import DropDown from "../../molecules/dropDown/DropDown";

const Products = React.forwardRef((
  {
    onCreateNewCategory,
    onChangeCategory,
    onCreateProduct,
    currentIdCategory =-1,
    listCategories =[],
    selectCurrentIdCategory,
    deleteCategory,
    showModalNewCategory,
    editCategory,
    saveCategory,
    onCloseModal,
    loadingSave,
    newCategory,
    listProducts,
    onChangeCategoryProduct,
    deleteProducts,
    loadingAction,
    setCategory,
    editProduct,
  }
  , ref) => {

  const [ isEditCategory, setIsEditCategory ] = useState(false);
  const currentCategory = listCategories.find(item=> item.id === currentIdCategory);


  const clearCategory=()=>{
    setIsEditCategory(false);
    setCategory({});
  };

  const onSaveCategory = () => {
    if(isEditCategory){
      editCategory();
    }else{
      saveCategory();
    }
    setTimeout(()=>{clearCategory();},[2500]);
  };

  return (
    <div className="container-products-template" ref={ref}>
      <div className={`container-fist-section d-flex`}>
        <div className={`title-container`}>
          <h2>PRODUCTOS</h2>
        </div>
        <div className={`buttons`}>
          <div className={`d-flex button-1`}>
            <img onClick={onCreateNewCategory} src={`${pathServer.PATH_ICONS}icon_add.svg`}  alt="añadir 1"/>
            <p>AGREGAR CATEGORÍA</p>
          </div>

          {
            currentIdCategory !==-1 &&
            <div className={`d-flex button-1`}>
              <img onClick={()=>{ setIsEditCategory(true); onCreateNewCategory(); setCategory({...currentCategory})}}
                   src={`${pathServer.PATH_ICONS}icon_edit.svg`} width="20" alt="editar"/>
              <p>EDITAR CATEGORÍA</p>
            </div>
          }

          <div className={`d-flex button-2`}>
            <img src={`${pathServer.PATH_ICONS}icon_add.svg`} onClick={onCreateProduct}  alt="añadir 2"/>
            <p>NUEVO PRODUCTO</p>
          </div>
        </div>
      </div>
      <div className={`container-second-section d-flex`}>
        <div className='d-flex-MultiLine'>
          <Button className={currentIdCategory ===-1 ? 'active-button m-y-1': 'm-y-1'} onClick={()=>selectCurrentIdCategory(-1)}>Ver todas</Button>
          {
            listCategories.map(item=>{
              return (
                <Button
                  key = {item.id}
                  onClick={()=>selectCurrentIdCategory(item.id)}
                  onClickIcon = {()=> {setIsEditCategory(false); deleteCategory(item.id);}}
                  className={currentIdCategory === item.id ? 'active-button m-y-1': 'm-y-1'}
                  icon={currentIdCategory === item.id  && item.description !== 'Otros' ? 'deny': null}>
                  {item.description}
                </Button>
              );
            })
          }
        </div>
      </div>

      <table className="w-100">
        <tbody>
        {
          listProducts.map(( product, index ) =>{
            return(
              <tr className={`products-item-container`} key = {product.id}>
                <td className={`edit-icon-delete`}  width="2%" >
                  {loadingAction === product.id ?
                    <PSLoading color="red" width={18} height={18}/> :
                    <PSIcon type="trash" onClick={()=>deleteProducts(product)}/>
                  }

                </td>
                <td className={`edit-icon-container`}  width="2%" >
                  <img src={`${pathServer.PATH_ICONS}icon_edit.svg`} width="20" alt="editar" onClick={()=>editProduct(product)}/>
                </td>
                <td className={`preview-image-container`} width="7%">
                  <img src={product.linkPhoto}/>
                </td>
                <td className={`title-container`}  width="12%">
                  <p>{product.title}</p>
                </td>
                <td className={`publication-date-container`}  width="10%">
                  <p>{product.dateCreated}</p>
                </td>
                <td  width="10%">
                  <DropDown
                    options={[...mapToSelect(listCategories,"id","description")]}
                    selectedValue={product.idCategory}
                    onSelectValue={(e)=>onChangeCategoryProduct(e.target.value, product, index)}
                  />
                </td>
              </tr>
            )
          })
        }
        </tbody>
      </table>


      {
        showModalNewCategory &&
        <ModalCategory
          openModal={showModalNewCategory}
          onCancel={()=>{ clearCategory();  onCloseModal();}}
          title={ isEditCategory  ?  'EDIT CATEGORÍA' : 'CREAR NUEVA CATEGORÍA'}
          labelButton= { isEditCategory  ?  'EDIT' : 'CREAR'}
          onSave={onSaveCategory}
          onChange={onChangeCategory}
          needFavorite={true}
          loading={loadingSave}
          onClose={()=>{ clearCategory(); onCloseModal();}}
          newCategory={newCategory}
        />
      }

    </div>
  );
});

Products.displayName = 'Products';

Products.defaultProps = {

};

Products.propTypes = {


};

export default Products;
